import { render, staticRenderFns } from "./AppSimpleCheckbox.vue?vue&type=template&id=28e57b82&scoped=true&"
import script from "./AppSimpleCheckbox.vue?vue&type=script&lang=js&"
export * from "./AppSimpleCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./AppSimpleCheckbox.vue?vue&type=style&index=0&id=28e57b82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e57b82",
  null
  
)

export default component.exports